import { render, staticRenderFns } from "./CheckboxRadio.vue?vue&type=template&id=8f9b21a2&scoped=true"
import script from "./CheckboxRadio.vue?vue&type=script&lang=js"
export * from "./CheckboxRadio.vue?vue&type=script&lang=js"
import style0 from "./CheckboxRadio.vue?vue&type=style&index=0&id=8f9b21a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9b21a2",
  null
  
)

export default component.exports